
import { useEffect } from "react";
import { Navigation } from "@/components/Navigation";
import { CommunityTabs } from "@/components/community/CommunityTabs";
import { JournalTab } from "@/components/community/JournalTab";
import { useSession } from "@supabase/auth-helpers-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { useFeatureLimit } from "@/hooks/useFeatureLimit";
import { CommunityHeader } from "@/components/community/CommunityHeader";

export default function Journal() {
  const session = useSession();
  const navigate = useNavigate();
  const { toast } = useToast();
  const { checkRemainingUses, features } = useFeatureLimit();

  // Ensure the page scrolls to top on load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSignInPrompt = () => {
    toast({
      title: "Sign In Required",
      description: "Please sign in to use more journal features.",
    });
    navigate('/premium');
  };

  const remainingJournalEntries = checkRemainingUses(features.JOURNAL_ENTRY.key);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1A1A25] to-[#0F111A] text-white pb-52">
      <div className="container py-8">
        <CommunityHeader />
        
        <div className="max-w-3xl mx-auto mt-6">
          {session || remainingJournalEntries > 0 ? (
            <JournalTab 
              remainingFreeEntries={remainingJournalEntries}
            />
          ) : (
            <Card className="p-6 bg-[#151520]/80 backdrop-blur-sm border-[#333344] text-white">
              <h3 className="text-xl font-medium text-center mb-4">Weekly Limit Reached</h3>
              <p className="text-center mb-6">
                You've used your free weekly journal entry. Sign in to create and view more entries.
              </p>
              <div className="flex justify-center">
                <Button 
                  onClick={handleSignInPrompt}
                  className="bg-blue-600 hover:bg-blue-700"
                >
                  Sign In / Sign Up
                </Button>
              </div>
            </Card>
          )}
        </div>
      </div>
      <CommunityTabs />
      <div className="relative">
        <Navigation />
      </div>
    </div>
  );
}
